import React from 'react';
import { observer } from 'mobx-react';
import ContactsVM from '../ContactsVM';
import { Neo, Views } from '@singularsystems/neo-react';
import { ITaskRunner, Model } from '@singularsystems/neo-core';
import ContactsEditModal from './ContactsEditModal';
import ContactLookup from "../../../Models/Contacts/ContactLookup";

interface IContactAutoCompleteDropdownProps {
    taskRunner?: ITaskRunner;
    bind: Model.IPropertyInstance<number | null>;
    bindDisplay: Model.IPropertyInstance<string | null>;
    parentName?: string;
    /** Called when a contact is selected, or when a contact is saved. */
    onChanged?: (contact?: ContactLookup) => void;
}

@observer
export default class ContactAutoCompleteDropdown extends Views.ViewComponentBase<IContactAutoCompleteDropdownProps, ContactsVM> {

    constructor(props: IContactAutoCompleteDropdownProps) {
        super(props, new ContactsVM(props.taskRunner, props.parentName));
    }

    public render() {
    const { bind, bindDisplay, onChanged } = this.props;

        return (
            <div>
                <Neo.AutoCompleteDropDown
                    bind={bind}
                    bindDisplay={bindDisplay}
                    itemSource={this.viewModel.apiClient.getContactLookups}
                    append={<Neo.Button icon={bind.value !== null ? "edit" : "plus"}
                        tooltip={bind.value !== null ? "Edit contact" : "New contact"}
                        onClick={() => { this.viewModel.editContact(bind.value); }} />}
                    onItemSelected={onChanged}
                    option={item => <>
                        <div style={{ flexBasis: 100 }}>{item.firstName}</div>
                        <div style={{ flexBasis: 100 }}>{item.lastName}</div>
                        <div style={{ flexBasis: 100 }}>{item.emailAddress}</div>
                    </>}
                />
                <ContactsEditModal viewModel={this.viewModel} bind={bind} bindDisplay={bindDisplay} onSaved={onChanged} />
            </div>
        );
    }
}